// TODO: connect to the API and replace this mock with /api/home/hero

import { HeroCarouselData } from '../models/hero.model';

export const MOCK_HERO_DATA: HeroCarouselData = {
  autoplayMs: 7000,
  loading: false,
  slides: [
    {
      id: 'discover-tiles',
      type: 'tiles',
      eyebrow: 'Siempre actualizados',
      headline: 'Explora tus TCG favoritos, sellados y accesorios',
      subheadline:
        'Encuentra tus productos favoritos, las singles que tanto llevas buscando, las mejores ofertas y las novedades más esperadas.',
      badge: {
        label: 'Nuevos ingresos semanales',
        route: '/tienda',
        queryParams: { sort: 'newest' },
      },
      primaryAction: {
        label: 'Explorar catalogo',
        route: '/tienda',
      },
      secondaryAction: {
        label: 'Ver novedades',
        route: '/tienda',
        queryParams: { filter: 'new' },
      },
      tiles: [
        {
          id: 'tile-pokemon',
          title: 'Pokemon TCG',
          subtitle: 'Singles y sellados',
          route: '/tienda/pokemon-tcg',
          image: {
            imageUrl: '/images/home/hero_01.jpg',
            alt: 'Pokemon cards on a play surface',
            width: 900,
            height: 600,
          },
        },
        {
          id: 'tile-magic',
          title: 'Magic: The Gathering',
          subtitle: 'Sets, accesorios y singles',
          route: '/tienda/magic-the-gathering-tcg',
          image: {
            imageUrl: '/images/demo/tiles-magic.jpg',
            alt: 'Magic cards and accessories arranged as a featured category tile',
            width: 1024,
            height: 1024,
          },
        },
        {
          id: 'tile-board-games',
          title: 'Perrón Singles',
          subtitle: 'Singles de todos los TCGs',
          route: '/tienda/perron-singles',
          image: {
            imageUrl:
              '/images/logo/perron_singles.jpeg',
            alt: 'Singles de TCGs de Perrón Store',
            width: 900,
            height: 1200,
          },
        },
        {
          id: 'tile-accessories',
          title: 'Accesorios',
          subtitle: 'Sleeves, binders y deck boxes',
          route: '/tienda/accesorios-para-tcg',
          image: {
            imageUrl: '/images/home/hero_02.jpg',
            alt: 'Gaming accessories and controllers on a desk',
            width: 900,
            height: 600,
          },
        },
        {
          id: 'tile-community',
          title: 'Torneos y comunidad',
          subtitle: 'Eventos para volver a la tienda',
          route: '/tienda',
          image: {
            imageUrl: '/images/home/hero_03.jpg',
            alt: 'Players gathered around a tabletop event',
            width: 900,
            height: 600,
          },
        },
      ],
    },
    {
      id: 'featured-product',
      type: 'media-right',
      eyebrow: 'Featured singles',
      headline: 'Singles premium listas para compra rápida',
      subheadline:
        'Encuentra cartas como ésta en nuestra tienda, para completar tus decks y colecciones favoritas.',
      badge: {
        label: 'NM disponible hoy',
        route: '/tienda',
        queryParams: { featured: 'true' },
      },
      primaryAction: {
        label: 'Comprar singles',
        route: '/tienda/perron-singles',
        queryParams: { category: 'singles' },
      },
      secondaryAction: {
        label: 'Ver destacados',
        route: '/tienda/perron-singles',
        queryParams: { sort: 'featured', availability: 'in_stock' },
      },
      media: {
        imageUrl:
          '/images/home/hero2.png',
        alt: 'Featured premium trading card',
        width: 1000,
        height: 1397,
      },
    },
    {
      id: 'featured-expansion',
      type: 'angled-media',
      eyebrow: 'NUEVOS TCGS Y EXPANSIONES',
      headline: 'Nuevos TCGs disponibles en Perrón Store y nuevas expansiones',
      subheadline:
        'Agregamos a nuestro catálogo nuevos juegos populares constantemente y mantenemos actualizados sus sets y expansiones.',
      badge: {
        label: 'Pre-orders abiertas',
        route: '/tienda/precompras',
      },
      primaryAction: {
        label: 'Ver novedades',
        route: '/tienda',
        queryParams: { filter: 'new' },
      },
      secondaryAction: {
        label: 'Precompras',
        route: '/tienda/precompras',
      },
      media: {
        imageUrl: '/images/demo/expansion.jpg',
        alt: 'Echoes of Verdant Realm expansion artwork with featured card frame',
        width: 1920,
        height: 1072,
        desktopFocalPoint: {
          x: 58,
          y: 34,
        },
        mobileFocalPoint: {
          x: 50,
          y: 40,
        },
      },
    },
    {
      id: 'event-background',
      type: 'background',
      eyebrow: 'Torneos y eventos',
      headline: 'Todas las semanas tenemos Torneos y eventos en Perrón Store',
      subheadline:
        'En Perrón Store puedes jugar, aprender y competir en tus juegos favoritos.',
      badge: {
        label: 'Prepárate para el próximo evento',
        route: '/tienda',
      },
      primaryAction: {
        label: 'Prepárate con singles',
        route: '/tienda/perron-singles',
      },
      secondaryAction: {
        label: 'Accesorios para eventos',
        route: '/tienda/accesorios-para-tcg',
      },
      backgroundImage: {
        imageUrl: '/images/demo/event-hero.jpg',
        alt: 'Event hero image for tournaments and special store announcements',
        width: 1920,
        height: 1072,
      },
      overlayStrength: 'medium',
      contentAlign: 'center',
    },
  ],
};
